// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1nm4A";
var _3 = "name-3v-_H";
var _4 = "item--eil4";
var _5 = "button-1K68s";
export { _1 as "__esModule", _2 as "wrapper", _3 as "name", _4 as "item", _5 as "button" }
export default { "__esModule": _1, "wrapper": _2, "name": _3, "item": _4, "button": _5 }
